import { render, staticRenderFns } from "./AnmeldungUebertragenModal.vue?vue&type=template&id=b14db982&"
import script from "./AnmeldungUebertragenModal.vue?vue&type=script&lang=js&"
export * from "./AnmeldungUebertragenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports